import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import api from '../../utils/api';

export const meta = {
  id: 'my_hours',
  category: 'personal',
  titleKey: 'dashboard.widgets.myHours',
  descriptionKey: 'dashboard.widgets.myHoursDesc',
  defaultSize: 'sm',
  icon: Clock,
};

// Personal time-tracked hours summary for the current agent. Backed by
// /api/time/me/summary which excludes breaks. Click → /my-tickets.
export default function MyHoursWidget() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: ['time-me-summary'],
    queryFn: () => api.get('/time/me/summary').then(r => r.data),
    refetchInterval: 5 * 60 * 1000,
  });

  const today = (parseInt(data?.today_minutes) || 0) / 60;
  const week = (parseInt(data?.week_minutes) || 0) / 60;
  const month = (parseInt(data?.month_minutes) || 0) / 60;
  const entries = parseInt(data?.today_entries) || 0;

  return (
    <div className="card" style={{ cursor: 'pointer', height: '100%' }} onClick={() => navigate('/my-tickets')}>
      <div className="card-header">
        <div className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Clock size={16} />
          {t('dashboard.widgets.myHours')}
        </div>
      </div>
      <div style={{ padding: '12px 20px 18px' }}>
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--c-brand)' }}>
            {today.toFixed(1)}<span style={{ fontSize: 14, fontWeight: 500, color: 'var(--c-text-muted)', marginLeft: 4 }}>{t('dashboard.widgets.myHoursUnit', 'h')}</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--c-text-muted)', marginTop: 2 }}>
            {t('dashboard.widgets.myHoursTodayCount', { count: entries, defaultValue: '{{count}} entries today' })}
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--c-border)', paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Row label={t('dashboard.widgets.myHoursWeek', 'This week')} value={`${week.toFixed(1)}h`} />
          <Row label={t('dashboard.widgets.myHoursMonth', 'This month')} value={`${month.toFixed(1)}h`} />
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontSize: 12, color: 'var(--c-text-muted)' }}>{label}</span>
      <span style={{ fontSize: 14, fontWeight: 600 }}>{value}</span>
    </div>
  );
}
